import _ from 'lodash'

import { d } from 'core/service/lib/decimal'
import VALUES from 'core/data-model/constants/values'
import { round, formatNumber, roundDown } from 'core/service/lib/number-format'
import { _accumulateBasicPremium } from '../benefit-illustration/policy-value'

export const findDividendRate = (productCode, dividendRates) =>
  _.find(dividendRates, (rate) => rate.productCode === productCode)

export const queryDividendRate = (gender, age, policyYear, filteredDividendRates) => {
  const queryAge = age.unit !== 'year' ? 0 : age.value
  return _.get(filteredDividendRates, ['dividendRates', gender, queryAge.toString(), policyYear.toString()], 0)
}

export const calculateCurrentIndex = (yearEnd, idxGrowth) => {
  const indexGrowth = idxGrowth / 100
  return round(
    d(1)
      .plus(indexGrowth)
      .pow(yearEnd)
      .mul(VALUES.GLOBAL_INDEX_16_6_VALUE_FIXED_INDEX),
    4
  )
}

export const calculateDividendGlobalIndexProduct = (currentIndex, accumulateBasicPremium) => {
  const maxOfCurrentIndex = Math.max(
    d(currentIndex)
      .dividedBy(VALUES.GLOBAL_INDEX_16_6_VALUE_FIXED_INDEX)
      .minus(1),
    0
  )

  const exchangeRate =
    VALUES.GLOBAL_INDEX_16_6_VALUE_EXCHANGE_RATE_FIRST_DAY / VALUES.GLOBAL_INDEX_16_6_VALUE_EXCHANGE_RATE_LAST_DAY
  return round(
    d(accumulateBasicPremium)
      .mul(VALUES.GLOBAL_INDEX_16_6_VALUE_PAR_RATIO)
      .mul(maxOfCurrentIndex)
      .mul(exchangeRate),
    2
  )
}

export const calculateDividendSurrender = (nonGuaranteeDividend, parForSurrender) =>
  round(d(nonGuaranteeDividend).mul(parForSurrender), 2)
